import { LockKeyhole } from "lucide-react";
import "./syre-lock-bonus.css";

interface BonusCountdown {
  days: number;
  hours: number;
  minutes: number;
}

export function SyreLockBonus({ lockCount, remaining }: { lockCount: number; remaining: BonusCountdown | null }) {
  const value = lockCount * 100;

  return (
    <div
      className="syre-lock-bonus relative isolate w-full overflow-hidden rounded-xl border px-2 py-2 text-left"
      role="note"
      aria-label={`${lockCount} total locks included during the bonus, valued at $${value.toLocaleString("en-US")}`}
      data-testid={`badge-syre-lock-bonus-${lockCount}`}
    >
      <div className="flex items-center justify-center gap-2">
        <LockKeyhole aria-hidden="true" className="h-5 w-5 shrink-0" strokeWidth={2.2} />
        <span className="min-w-0 leading-tight">
          <span className="block whitespace-nowrap text-[10px] font-extrabold uppercase sm:text-[11px] sm:tracking-wide">{lockCount}-lock bonus</span>
          <span className="mt-0.5 block text-xs font-semibold">${value.toLocaleString("en-US")} value</span>
          <span className="mt-1 block text-[9px] font-semibold leading-tight">Total included during bonus</span>
        </span>
      </div>
      {remaining && <div className="mt-2 border-t border-brand-dark/15 pt-2 text-center">
        <span className="block text-[9px] font-semibold uppercase tracking-wide">Bonus ends in</span>
        <div className="mt-1 grid grid-cols-3 gap-1 tabular-nums">
          {([
            { value: remaining.days, label: "days" },
            { value: remaining.hours, label: "hours" },
            { value: remaining.minutes, label: "minutes" },
          ]).map(({ value: count, label }) => <span key={label} className="min-w-0">
            <strong className="block text-base leading-none">{count}</strong>
            <span className="mt-1 block text-[9px] leading-none">{label}</span>
          </span>)}
        </div>
      </div>}
    </div>
  );
}
